export function getParam(param) {
  var search = window.location.href
    .match(/\?.+/gi)[0]
  var params = new URLSearchParams(search);

  return params.get(param);
};
